import React from "react";
import {Card, List, Typography, Popover} from "antd";
import moment from "moment";
import {isNumber} from "lodash";
import {ListHeader, ListItemContainer} from "./CourierWalletInvoicesList.styles";
import JSONInput from "react-json-editor-ajrm";
import {InfoCircleOutlined} from "@ant-design/icons";
import {useStore} from "@vigo/hooks";
const {Text} = Typography;
import {RetryInvoiceIdAccountButton} from "../../retryInvoiceAccountButton/RetryInvoiceIdAccountButton";

export const CourierWalletInvoicesList = ({
    paymentInvoices,
    onItemSelect,
    selectedItem,
    loading
}) => {
    const stores = useStore();
    const isAgency = stores.meStore.checkRole("isAgency");
    return (
        <Card
            loading={loading}
            title={
                <ListHeader>
                    <span>Faturalar</span>
                </ListHeader>
            }
            bodyStyle={{padding: "0px"}}
        >
            <List
                dataSource={paymentInvoices || []}
                style={{height: "500px", overflow: "auto", padding: "24px"}}
                renderItem={item => {
                    const isSelected =
                        selectedItem && selectedItem?._id?.toString() === item._id.toString();

                    return (
                        <List.Item
                            style={{
                                padding: "24px",
                                cursor: "pointer",
                                backgroundColor: isSelected ? "#f0f0f0" : "transparent"
                            }}
                            onClick={() => onItemSelect(item._id)}
                        >
                            <ListItemContainer>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <Text>
                                        <b>Fatura ID</b> : {item?.invoiceId}{" "}
                                        {!isAgency && (
                                            <Popover
                                                content={
                                                    <JSONInput
                                                        id="paymentInvoiceJSON"
                                                        placeholder={item}
                                                        theme="dark_mitsuketa_tribute"
                                                        width="auto"
                                                        height="auto"
                                                        viewOnly={true}
                                                        confirmGood={false}
                                                    />
                                                }
                                            >
                                                <InfoCircleOutlined />
                                            </Popover>
                                        )}
                                    </Text>
                                    <Text>
                                        <b>Oluşturulma Tarihi</b> :{" "}
                                        {item?.createdAt
                                            ? moment(item.createdAt).format("DD MMMM YYYY HH:mm")
                                            : ""}
                                    </Text>
                                    <Text>
                                        <b>Durum</b> : {item?.status}
                                    </Text>
                                    <div>
                                        {item?.status === "Hata Aldı." && (
                                            <RetryInvoiceIdAccountButton
                                                invoiceId={item?.invoiceId}
                                            />
                                        )}
                                    </div>
                                </div>
                                <Text strong type={item.amount >= 0 ? "success" : "danger"}>
                                    {isNumber(item?.amount)
                                        ? item?.amount?.toLocaleString("tr-TR", {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                          })
                                        : "-"}{" "}
                                    ₺
                                </Text>
                            </ListItemContainer>
                        </List.Item>
                    );
                }}
            />
        </Card>
    );
};
